import React from "react";
import "./header.css";

const Header = () => {
  return (
    <div className='free-course d-flex flex-row flex-wrap align-content-center justify-content-center p-0'>
      <h1 className='col-12 col-md-9 col-lg-10 free-course-header'>
        No More Paid Courses <br />
        Learn Everything For Free
      </h1>
    </div>
  );
};

export default Header;
